import { registerLocaleData } from '@angular/common';
import { es_ES } from 'ng-zorro-antd';
import es from '@angular/common/locales/es';
registerLocaleData(es);
const ɵ0 = es_ES;
export class AppModule {
}
export { ɵ0 };
